/**
 * The shared utils
 *
 * @copyright 2018 Linguistica 360
 */

import $ from 'jquery';

import { PROGRAM_URLS } from './config.js';

const urls = PROGRAM_URLS;

export function ucfirst(text) {
    return text[0].toUpperCase() + text.slice(1);
}

export function getConfig(key) {
    return window._NiSC[key];
}

export function resolveUrl(path, scope = 'local') {
    if (scope === 'local') scope = getConfig('scope');

    const root = getConfig('root');
    const scopeUrl = urls[scope] ? `${root}/${urls[scope]}/` : root;
    return `/${scopeUrl}/${path}`.replace(/\/+/g, '/');
}

export function resolveRoot(path) {
    return resolveUrl(path, 'root');
}

export function makeTooltips(text) {
    return text.replace(/{(.*?)=(.*?)}/g, (_, phrase, translation) => {
		translation = escapeAttribute(translation);

		if (/^\[(\d+)\]$/.test(translation)) {
			const episode = parseInt(translation.substr(1));
			const target = 'target="_blank"';
            const href = `episode/${episode}`;
			const ref = 'data-tooltip-reference="expressions"';

			return `<a ${ref} data-href="${href}" ${target}>${phrase}</a>`;
		}

        return `<span data-tooltip="${translation}">${phrase}</span>`;
    });
}

export function makeDialog(text) {
	const replace = '</td></tr><tr class="toprow"><td class="leftcol">$2:</td><td class="data">';
    text = text.replace(/(^|[\n\r])\s*([^:]+):/gi, replace);

	if (text.search('</td></tr>') === 0) text = text.substr(10) + '</td></tr>';
	return `<table class="dialog-table">${text}</table>`;
}

export function ecapeHtml(unsafe) {
    return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

export function escapeAttribute(unsafe) {
    return unsafe.replace(/\\?"/g, '\\"');
}

export function $wrap(func, wrapJquery = true) {
    if (wrapJquery) return function (arg, arg1) { return func($(this), arg, arg1); };
    else return function (arg, arg1) { return func(this, arg, arg1); };
}

export function $val($element) {
    if (!($element instanceof $)) $element = $($element);
    if ($element.is(':checkbox')) return $element.is(':checked') ? 'on' : 'off';
    return $element.val();
}

export function makeQuery(url, params) {
    return `${url}?` + Object.keys(params).map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
    }).join('&');
}

// money formatting TODO refactor - looks ugly af
export function moneyFormat(n, c, d, t) {
    c = isNaN(c = Math.abs(c)) ? 2 : c;
    d = d == undefined ? '.' : d;
    t = t == undefined ? ',' : t;

    const s = n < 0 ? '-' : '';
    const i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + '';
    let j = (j = i.length) > 3 ? j % 3 : 0;

   return s + (j ? i.substring(0, j) + t : '') +
       i.substring(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
       (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
}

export function hasGroup(group) {
    return getConfig('groups').includes(group);
}
